import {Button} from 'antd';
import React from 'react';

export default class TransferOperation extends React.Component {

  render() {
    const {
      moveToLeft,
      moveToRight,
      leftArrowText,
      rightArrowText,
      leftActive,
      rightActive,
      className,
      leftAllActive,
      moveAllToLeft,
      rightAllActive,
      moveAllToRight,
    } = this.props;

    const moveToRightButton = (
      <Button type="primary" size="small" disabled={!rightActive} onClick={moveToRight}>
        {<span><i className='icon-coms-Browse-box-Add-to'/></span>}
      </Button>
    );
    const moveToLeftButton = (
      <Button type="primary" size="small" disabled={!leftActive} onClick={moveToLeft}>
        {<span><i className='icon-coms-Browse-box-delete'/></span>}
      </Button>
    );

    const moveAllToRightButton = (
      <Button type="primary" size="small" disabled={!leftAllActive} onClick={moveAllToRight}>
        {<span><i className='icon-coms-Browse-box-add-all'/></span>}
      </Button>
    );
    const moveAllToLeftButton = (
      <Button type="primary" size="small" disabled={!rightAllActive} onClick={moveAllToLeft}>
        {<span><i className='icon-coms-Browse-box-Delete-all'/></span>}
      </Button>
    );
    return (
      <div className={className}>
        {moveToRightButton}
        {moveToLeftButton}
        {moveAllToRight && moveAllToRightButton}
        {moveAllToLeftButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-transfer/operation.js